import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { saveMessage } from "../TrackerService";

const ContactForm = () => {
    const [status, setStatus] = useState(null);
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm({
        mode: "onBlur",
    });

    const onSubmit = async (data) => {
        setStatus("sending");
        try {
            // 1. Save to Firestore (Backup / Admin Panel)
            await saveMessage(data);

            // 2. Submit to Forminit via direct API fetch
            const response = await fetch(
                `https://forminit.com/f/${process.env.REACT_APP_FORMINIT_FORM_ID}`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "X-API-KEY": process.env.REACT_APP_FORMINIT_API_KEY,
                    },
                    body: JSON.stringify({
                        blocks: [
                            {
                                type: "sender",
                                properties: {
                                    fullName: data.name,
                                    email: data.email,
                                },
                            },
                            {
                                type: "text",
                                name: "subject",
                                value: data.subject,
                            },
                            {
                                type: "text",
                                name: "message",
                                value: data.message,
                            },
                        ],
                    }),
                }
            );

            if (response.ok) {
                setStatus("success");
                reset();
                setTimeout(() => setStatus(null), 5000);
            } else {
                const errorData = await response.json();
                console.error("Forminit submission error:", errorData);
                setStatus("error");
            }
        } catch (error) {
            console.error("Form submission error:", error);
            setStatus("error");
        }
    };

    return (
        <form id="contact-form" onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
                <div className="col-md-6">
                    <div className="single-form">
                        <input
                            type="text"
                            placeholder="Your Name"
                            {...register("name", {
                                required: "Name is required",
                            })}
                        />
                        {errors.name && (
                            <p className="error">{errors.name.message}</p>
                        )}
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="single-form">
                        <input
                            type="email"
                            placeholder="Email Address"
                            {...register("email", {
                                required: "Email is required",
                                pattern: {
                                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                                    message: "invalid email address",
                                },
                            })}
                        />
                        {errors.email && (
                            <p className="error">{errors.email.message}</p>
                        )}
                    </div>
                </div>
                <div className="col-md-12">
                    <div className="single-form">
                        <input
                            type="text"
                            placeholder="Subject"
                            {...register("subject", {
                                required: "Subject is required",
                            })}
                        />
                        {errors.subject && (
                            <p className="error">{errors.subject.message}</p>
                        )}
                    </div>
                </div>
                <div className="col-md-12">
                    <div className="single-form">
                        <textarea
                            placeholder="Write your message here..."
                            {...register("message", {
                                required: "Message is required",
                            })}
                        ></textarea>
                        {errors.message && (
                            <p className="error">{errors.message.message}</p>
                        )}
                    </div>
                </div>

                <div className="col-md-12">
                    {status === "success" && (
                        <p className="form-message success">
                            Message sent successfully!
                        </p>
                    )}
                    {status === "error" && (
                        <p className="form-message error">
                            Failed to send message. Please try again.
                        </p>
                    )}
                    {status === "sending" && (
                        <p className="form-message info">Sending...</p>
                    )}
                </div>

                <div className="col-md-12">
                    <div className="form-btn">
                        <button type="submit" disabled={status === "sending"}>
                            {status === "sending"
                                ? "Sending..."
                                : "Send Message"}
                        </button>
                    </div>
                </div>
            </div>
        </form>
    );
};

export default ContactForm;
